import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

import Home from "./pages/Home";
import Results from "./pages/Results";
import FAQs from "./pages/FAQs";
import ContactUs from "./pages/ContactUs";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import ScrollToHash from "./components/ScrollToHash";
import PrivateBookings from "./pages/PrivateBookings";
import Memberships from "./pages/Memberships";
import AdminPortal from "./pages/AdminPortal";

// OIDC config for KAR admin (Cognito)
const oidcConfig = {
  // e.g. https://your-domain.auth.ca-central-1.amazoncognito.com
  authority: process.env.REACT_APP_COGNITO_DOMAIN,

  // App client ID from Cognito
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,

  // Where Cognito should redirect back after login
  redirect_uri:
    process.env.REACT_APP_COGNITO_REDIRECT_URI ||
    `${window.location.origin}/admin`,

  response_type: "code",
  scope: "openid profile email",
  automaticSilentRenew: true,
};

function App() {
  return (
    <AuthProvider {...oidcConfig}>
      <Router>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/results" element={<Results />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/private" element={<PrivateBookings />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/admin" element={<AdminPortal />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
